import React from 'react';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const IcNonCiscoHostedFabrics = /* @__PURE__ */ __name((properties) => /* @__PURE__ */ React.createElement("svg", {
  fill: "none",
  height: "24",
  width: "24",
  xmlns: "http://www.w3.org/2000/svg",
  ...properties
}, /* @__PURE__ */ React.createElement("path", {
  clipRule: "evenodd",
  d: "M12 2.81 4.041 7.405v9.19l7.96 4.596 7.959-4.595v-9.19L12 2.81Zm.75-1.877a1.5 1.5 0 0 0-1.5 0L2.791 5.817a1.5 1.5 0 0 0-.75 1.3v9.767a1.5 1.5 0 0 0 .75 1.3l8.46 4.883a1.5 1.5 0 0 0 1.5 0l8.459-4.884a1.5 1.5 0 0 0 .75-1.299V7.116a1.5 1.5 0 0 0-.75-1.299L12.75.933Z",
  fill: "var(--mds-nav-icon-weak)",
  fillRule: "evenodd"
}), /* @__PURE__ */ React.createElement("path", {
  d: "m7.94 12.868-1.2.7a.5.5 0 0 0 0 .864l4.63 2.7c.39.227.87.227 1.26 0l4.63-2.7a.5.5 0 0 0 0-.864l-1.2-.7-2.674 1.56c-.857.5-1.915.5-2.772 0l-2.674-1.56Z",
  fill: "var(--mds-nav-icon-medium)"
}), /* @__PURE__ */ React.createElement("path", {
  d: "M11.37 6.868a1.25 1.25 0 0 1 1.26 0l4.63 2.7a.5.5 0 0 1 0 .864l-4.63 2.7a1.25 1.25 0 0 1-1.26 0l-4.63-2.7a.5.5 0 0 1 0-.864l4.63-2.7Z",
  fill: "var(--mds-nav-icon-accent)"
})), "IcNonCiscoHostedFabrics");

export { IcNonCiscoHostedFabrics };
//# sourceMappingURL=ic-non-cisco-hosted-fabrics.js.map
